module.exports = __webpack_public_path__ + "img/analysis.79c76863.svg";